<template>
  <section class="academy-videos">
    <div class="academy-videos__filters row no-gutters">
      <div class="filters-item filters-item__label col-auto col-md-3">
        <IconFilter />
        <span>{{ $t('filter') }}</span>
      </div>
      <div @click="filterVideos('all')" class="filters-item filters-item__all col-auto"
        :class="{ 'active': selectedFilter === 'all' }">
        {{ $t('all') }}
      </div>
      <div class="filters-item col-auto" :class="{ 'active': selectedFilter === category.id }"
        v-for="category in getCategories" :key="category.id" @click="filterVideos(category.id)">
        <span>{{ category.title }} <span class="counter">({{ getSumOfCategoriesById(category.id) }})</span></span>
      </div>
    </div>
    <div class="academy-videos__searchbar  row no-gutters">
      <div class="col-md-3 border-right d-none d-md-block"></div>
      <div class="col-12 col-md-5 border-right">
        <input v-model="searchVideoInput" @input="doInputSearchVideo" class="academy-videos__searchbar-input"
          type="text" name="videoSearch" id="videoSearch" :placeholder="$t('searchVideo')" />
      </div>
    </div>
    <div class="row no-gutters border-top">
      <div
        class="academy-videos__loading"
        v-if="!filteredVideos.length && !emptyResults"
      >
        <Loading />
      </div>
      <div
        v-else-if="!filteredVideos.length && emptyResults"
        class="col-8 text-center mx-auto mt-5 academy-videos__empty-results"
      >
        <h4>{{ $t('emptySearch') }}</h4>
      </div>
      <section class="row no-gutters w-100" v-else >

        <div v-if="topRatedVideos.length" class="academy-videos__top-rated col-12 row no-gutters">
          <div class="col-12 col-lg-10 offset-lg-1 px-5 px-lg-0">
            <h3 class="academy-videos__top-rated-title">{{ $t('topRated') }}</h3>
          </div>
          <video-card
            v-for="video in topRatedVideos"
            isTopRated
            :video="video"
            :key="video.id"
          />
        </div>

        <video-card v-for="video in visibleVideos" :video="video" :key="video.id" />

      </section>
      <div class="col-12 text-center py-5" @click="loadMoreVideos" v-if="videosToShow < filteredVideos.length">
        <div class="b2b-load-more">
          <IconArrow /><span>{{ $t('loadMore') }}</span>
        </div>
      </div>
      <div class="col-10 py-5 offset-md-1 d-flex justify-content-end">
        <back-to-top />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoCard from './VideoCard.vue'
import IconArrow from '../../icons/IconArrow.vue'
import IconFilter from '../../icons/IconFilter.vue'
import BackToTop from '../BackToTop.vue'
import Loading from '../Loading.vue'

export default {
  name: 'VideosListing',
  components: {
    IconArrow, BackToTop, IconFilter, Loading, VideoCard
  },
  data: () => ({
    filteredVideos: [],
    topRatedVideos: [],
    videosToShow: 12,
    selectedFilter: 'all',
    searchVideoInput: '',
    emptyResults: false
  }),
  computed: {
    ...mapGetters(['getVideos', 'getCategories']),
    visibleVideos () {
      return this.filteredVideos.slice(0, this.videosToShow)
    }
  },
  methods: {
    getSumOfCategoriesById (id) {
      return this.getVideos.filter(category => category.category === id).length
    },

    getCategoryNameById (id) {
      return this.getCategories.find(category => category.id === id).title
    },

    loadMoreVideos () {
      if (this.videosToShow < this.getVideos.length) {
        this.videosToShow += 12
      }
    },
    /**
     * All filters stuff
     */
    filterVideos (categoryId) {
      this.selectedFilter = categoryId
      if (categoryId === 'all') {
        this.videosToShow = 12
        this.filteredVideos = this.getVideos
        // eslint-disable-next-line max-len
        this.sortTopRatedVideos(this.filteredVideos.filter(videoRating => videoRating.video_rating > 0))
        this.filteredVideos = this.cleanVideosDuplicates(this.filteredVideos, this.topRatedVideos)
      } else {
        this.videosToShow = 12
        this.filteredVideos = this.getVideos.filter(video => video.category === categoryId)
        // eslint-disable-next-line max-len
        this.sortTopRatedVideos(this.getCategories.find(category => category.id === categoryId).top_videos)

        this.filteredVideos = this.cleanVideosDuplicates(this.filteredVideos, this.topRatedVideos)
      }
    },
    /**
     * Fucntion to filter videos in FR to make it
     * appears first using the substring in description
     * @param {array} videos - array of videos
     * @param {string} string - search string inside description
     */
    reorderBySpecificString (array, string) {
      // eslint-disable-next-line max-len
      return array.sort((a, b) => a.description.includes(string) - b.description.includes(string))
    },
    getVideosFilteredByLanguage () {
      if (this.$store.getters.getLang === 'fr-CA') {
        this.filteredVideos = this.reorderBySpecificString(this.getVideos, '(Formation disponible en anglais)')
        // eslint-disable-next-line max-len
        this.sortTopRatedVideos(this.filteredVideos.filter(videoRating => videoRating.video_rating > 0))
      } else {
        this.filteredVideos = this.getVideos
        // eslint-disable-next-line max-len
        this.sortTopRatedVideos(this.filteredVideos.filter(videoRating => videoRating.video_rating > 0))
      }
      this.filteredVideos = this.cleanVideosDuplicates(this.filteredVideos, this.topRatedVideos)
    },
    sortTopRatedVideos (videos) {
      // eslint-disable-next-line max-len
      this.topRatedVideos = videos.sort((a, b) => a.video_rating - b.video_rating).slice(0, 4)
    },
    /**
     * Function to clean videos duplicates
     * @param {*} array1 use this to filter the original list of videos
     * @param {*} array2 and this to match the top videos and remove it from the original list
     */
    cleanVideosDuplicates (array1, array2) {
      return array1.filter(obj => !array2.some(obj2 => obj.id === obj2.id))
    },
    doInputSearchVideo () {
      this.selectedFilter = 'all'
      this.topRatedVideos = []

      if (this.searchVideoInput.length > 0) {
        // eslint-disable-next-line max-len
        this.filteredVideos = this.getVideos.filter(obj => Object.keys(obj).reduce((acc, curr) => acc || obj[curr].toString().toLowerCase().includes(this.searchVideoInput), false))

        if (this.filterVideos.length) {
          this.emptyResults = true
        } else {
          this.emptyResults = false
        }
      } else {
        this.emptyResults = false
        this.getVideosFilteredByLanguage()
      }
    },
    /**
     * Misc
     */
    getUrlParamaterByName (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
      const regex = new RegExp(`[\\?&]${name}=([^&#]*)`)
      const results = regex.exec(window.location.search)
      return results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }
  },
  mounted () {
    this.getVideosFilteredByLanguage()

    /**
     * Filter videos by category
     * if a category is selected in the url
     * or by video-id
     */
    if (this.getUrlParamaterByName('video_category')) {
      this.filterVideos(this.getUrlParamaterByName('video_category'))
    }

    if (this.getUrlParamaterByName('video_id')) {
      this.searchVideoInput = this.getUrlParamaterByName('video_id')
      this.doInputSearchVideo()
    }
  }
}

</script>

<style lang="scss">
.academy-videos {
  &__loading {
    width: 100%;
    height: 25rem;
    position: relative;
  }

  &__filters {
    border-top: 1px solid $grey-light;
    border-bottom: 1px solid $grey-light;
    overflow: scroll;
    flex-wrap: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */

    .filters-item {
      height: 5rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 5px;
      padding-left: 5px;
      font-size: 1.3rem;
      padding-left: 2%;
      padding-right: 2%;
      cursor: pointer;
      border-right: 1px solid $grey-light;
      border-bottom: 1px solid $grey-light;

      @include breakpoint('md') {
        height: 7rem;
        border-bottom: none;
      }

      span>span {
        font-weight: 600;
      }

      &__label {
        font-weight: 600;
        cursor: auto;
        padding-right: 2%;
        background-color: $red;
        color: white;
        text-transform: uppercase;

        svg {
          margin-right: 1.5rem;
          width: 1.8rem;
        }
      }

      &__all {
        font-weight: 600;
      }

      &.active,
      &:hover:not(.filters-item__label) {
        background-color: $menu-active;
        color: white;
      }
    }

  }

  &__searchbar {
    &-input {
      height: 70px;
      width: 100%;
      padding: 1rem 2rem;
      font-size: 2.1rem;
      border: none;
    }
  }
  &__top-rated  {
    padding-top: 5rem;
    padding-bottom: 6rem;

    border-bottom: 1px solid $grey-light;
  }
  &__top-rated-title {
    font-size: 3rem;
    margin-bottom: 4rem;
  }
}
</style>
